/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/22/21
 */

import React from "react";
import {Alert, Box, Button, Divider, Grid, Link, Paper, Stack, Typography} from "@mui/material";
import {format} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faConfluence, faJira, faSlack} from "@fortawesome/free-brands-svg-icons";
import Const from "./const.json";
import {useDispatch} from "react-redux";
import {logout} from "./state/reducers/user";
import {useNavigate} from "react-router-dom";
import HeroImg from "./media/images/hero.svg";

export default function Logout() {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const logBackIn = () => {
		navigate("/login");
	};

	React.useEffect(() => {
		dispatch(logout());
	}, [dispatch]);

	return (
		<Grid container alignContent="center" alignItems="center" direction="column">
			<Box m={6} />
			<Paper elevation={3} sx={{ width: "550px", maxWidth: "550px" }}>
				<Box p={3}>
					<Grid container alignContent="center" alignItems="center" direction="column">
						<div>
							<img src={HeroImg} alt={"Vega Calendar"} style={{width: "300px"}} />
						</div>
						<div>
							<Typography variant="h4">
								Vega Calendar
							</Typography>
						</div>
						<Box m={1} color="text.secondary" fontSize="fontSize">
							Version {process.env.REACT_APP_VERSION} ({format(Number(process.env.REACT_APP_BUILD_DATE), 'MMMM do, yyyy')})
						</Box>
						<Box m={1}>
							<Typography variant="body1">
								Human-friendly calendar for Atlassian teams
							</Typography>
						</Box>
						<Box m={2}>
							<Alert variant={"outlined"} color={"info"}>
								You have been successfully logged out.
							</Alert>
						</Box>
						<Box sx={{ m: 1 }}>
							<Button variant={"contained"} onClick={logBackIn}>Log back in</Button>
						</Box>

						<Stack m={2} spacing={2} direction={"row"} divider={<Divider orientation="vertical" flexItem />}>
							<Box>
								<FontAwesomeIcon style={{color: "#0065ff"}} icon={faConfluence} size="sm"/> <Link underline={"hover"} target="_blank" href={Const.URL_DOCS}>Docs</Link>
							</Box>
							<Box>
								<FontAwesomeIcon style={{color: "#998DD9"}} icon={faSlack} size="sm"/> <Link underline={"hover"} target="_blank" href={Const.URL_SLACK_CHANNEL}>{Const.SLACK_CHANNEL_NAME}</Link>
							</Box>
							<Box>
								<FontAwesomeIcon style={{color: "#0065ff"}} icon={faJira} size="sm"/> <Link underline={"hover"} target="_blank" href={Const.URL_CONTACT}>Contact us</Link>
							</Box>
							<Box>
								<FontAwesomeIcon style={{color: "#0065ff"}} icon={faConfluence} size="sm"/> <Link underline={"hover"} target="_blank" href={Const.URL_CST_CONFLUENCE}>go/cst</Link>
							</Box>
						</Stack>
					</Grid>
				</Box>
			</Paper>
		</Grid>
	);

}
